/**
 * Alert Action Enum
 * Represents the action keys returned by the alerts API
 */
export enum AlertActionEnum {
  SUBMIT_NAFATH = 'submit_nafath',
  SUBMIT_KYC = 'submit_kyc',
  RENEW_KYC = 'renew_kyc',
  ADD_BANK_ACCOUNT = 'add_bank_account',
  SUBMIT_WAKALA = 'submit_wakala',
}
